<template>
  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'order-reset'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
          <b-field grouped>
            <b-input :placeholder="$t('basket-number')"
                v-model="basketNumber"
                icon="shopping-cart">
            </b-input>
            <div class="control" v-if="basketNumberValid">
                <button class="button is-info" @click.prevent="resetBasket">{{ $t ("order-reset") }}</button>
            </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import MenuVert from "./MenuVert"
import { mapGetters } from "vuex"
import axios          from "axios"

export default {
    name: "OrderReset",
    data () {
        return { basketNumber : ""}
    },
    components:{
        MenuVert,
    },
    computed: {
        ...mapGetters(["getCurrentCompany", "getUserToken"]),
        basketNumberValid () {
            let bn = this.basketNumber.replace(/^0+/, '')
            let len = bn.length
            let head = bn.substr (0, 2)
            if (len >= 4) {
                if (head == "20")
                    return len == 10
                if (head == "99")
                    return len == 8
                return true
            }
            return false
        }
    },
    methods: {
        resetBasket () {
            let bn   = this.basketNumber.replace(/^0+/, '')
            let uri  = "/vue/basket/" + bn + "/reset/"
            let self = this
            axios.post (uri, {},
                { headers: { Authorization: "Token " + this.getUserToken } }
            ).then (response => {
                let rdata = response.data
                if (rdata.status == true) {
                    self.$buefy.toast.open({
                        message: self.$t ("basket-reset-successful"),
                        type: 'is-success'
                    })
                } else {
                    self.$buefy.toast.open({
                        message: rdata.messages.join ("<br />"),
                        type: 'is-error'
                    })
                }
            })
        }
    }
}
</script>
